import _ from 'lodash';
import faqCategoryTemplate from './faq-category.html';

import faqCategoryDialogTemplate from '../faq-category-dialog/faq-category-dialog-template.html';
import FaqCategoryDialogController from '../faq-category-dialog/faq-category-dialog-controller';

import faqEntryDialogTemplate from '../faq-entry-dialog/faq-entry-dialog-template.html';
import FaqEntryDialogController from '../faq-entry-dialog/faq-entry-dialog-controller';

// eslint-disable-next-line no-undef
@Inject('$sce', 'Notifications', 'gettextCatalog')
class FaqCategoryController {
  constructor() {
    this.faqDndTree = {
      accept: (sourceNodeScope, destNodesScope) => this.api.accept(sourceNodeScope, destNodesScope),
      dropped: (event) => this.api.dropped.run(event),
    };
  }

  openCategoryDialog(category) {
    this.Notifications.showComplexDialog({
      template: faqCategoryDialogTemplate,
      bindToController: true,
      controller: FaqCategoryDialogController,
      resolve: {
        moduleName: () => 'faqCategory',
        namespace: () => 'faq',
        category: () => category,
        title: () => this.gettextCatalog.getString('Edit Category'),
        language: () => this.model.faq.faq.language || this.model.session.locale,
        api: () => this.api.faqDialogApi,
      },
    }).result.then((category) => {
      this.api.updateCategory.run(category);
    });
  }

  openEntryDialog(entry) {
    this.Notifications.showComplexDialog({
      template: faqEntryDialogTemplate,
      bindToController: true,
      controller: FaqEntryDialogController,
      resolve: {
        moduleName: () => 'faqEntry',
        namespace: () => 'faq',
        entry: () => _.cloneDeep(entry),
        title: () => this.gettextCatalog.getString('Edit Question'),
        language: () => this.model.faq.faq.language || this.model.session.locale,
        api: () => this.api.faqDialogApi,
        saveEntry: () => this.api.saveEntry,
      },
    });
  }

  deleteCategoryHandler(category) {
    if (!this.hasEntries(category)) {
      this.api.deleteCategory
        .run(category)
        .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Category has been removed')));
    } else {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Category has entries'));
    }
  }

  hasEntries(category) {
    return category.entries.length > 0;
  }

  deleteEntryHandler($event, entry) {
    this.api.deleteEntry.run(entry).then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Entry has been removed')));
  }

  trustAsHtml(string) {
    return this.$sce.trustAsHtml(string);
  }
}

export default class FaqCategoryComponent {
  constructor() {
    this.template = faqCategoryTemplate;
    this.controller = FaqCategoryController;
    this.bindings = {
      model: '<',
      editMode: '<',
      api: '<',
    };

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/faq/components/faq-category/faq-category-component.js